import React from 'react'

import { useFlag } from 'containers/flags'
import useUserProfile from 'modules/user/useUserProfile'
import { PrototypeView } from './PrototypeView'
import { PrototypeViewOld } from './PrototypeViewOld'
import { PrototypeLoadingPlaceholder } from './PrototypeView/components/PrototypeLoadingPlaceholder'

export function PrototypeViewFFGate() {
  const { loading } = useUserProfile(false)
  const isBetterPrototypeNavBarOn = useFlag('better-prototype-nav-bar')

  if (loading) return <PrototypeLoadingPlaceholder />

  if (isBetterPrototypeNavBarOn) {
    return <PrototypeView />
  } else {
    return <PrototypeViewOld />
  }
}
